const SvgIcon = ({isActive, size = '16', color = '#000' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg1604"
    width={size}
    height={size}
    fill={isActive === true ? "#f00" : "none"}
    version="1.1"
    viewBox="0 0 16 16"
  >
    <g
      id="g1597"
      strokeWidth="0.802"
      clipPath="url(#clip0_486_301)"
      transform="matrix(1.24627 0 0 1.24627 -1.347 -1.347)"
    >
      <path
        id="path1595"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="0.5"
        strokeWidth="1.605"
        d="M1.875 7.5a5.625 5.625 0 1 1 11.25 0 5.625 5.625 0 0 1-11.25 0"
      ></path>
    </g>
    <defs id="defs1602">
      <clipPath id="clip0_486_301">
        <path id="rect1599" fill="#fff" d="M0 0h15v15H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default SvgIcon;
